React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
Auth = require 'app/scripts/db/auth'
View = require 'app/scripts/views/internal/view'
{ getOrganizationUrl } = require 'app/scripts/controller/urls'
{ logError } = require 'app/scripts/debug/log-error'
{ Feature } = require 'app/scripts/debug/constants'

{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports = class FreeTrialBanner extends View
  initialize: ->
    @loadBannerPromise ?= `import(/* webpackChunkName:"free-trial-banner"*/'app/src/components/FreeTrial')`
      .then((module) =>
        try
          @FreeTrialBanner = module.FreeTrialBanner
          @render()
        catch err
          logError({
            error: err,
            tags: {
              ownershipArea: 'trello-bizteam',
              feature: Feature.FreeTrialExistingTeam,
            }
          })
      )

  render: ->
    if (!@FreeTrialBanner)
      return @

    props = {}

    if @model.typeName == 'Member'
      url = window.location.pathname
      org = @model.organizationList.models.find (orgModel) ->
        # Show banner in any route that follows this path /{teamName}/*
        orgUrl = "/#{ orgModel.get('name') }/"
        return url.includes(orgUrl)

      if org
        props.orgId = org.id

    if @model.typeName == 'Organization'
      props.orgId = @model.id

    if @model.typeName == 'Board' && !@model.isGuest(Auth.me())
      props.orgId = @model.get('idOrganization')

    if !props.orgId
      return @

    banner = React.createElement(@FreeTrialBanner, props)
    renderComponent(banner, @el)
    @

  remove: ->
    ReactDOM.unmountComponentAtNode(@el)
    super
